/**
 * Labor hours per task — UL508A / NFPA 79 assembly standards
 * Based on MCC shop industry benchmarks
 * All values = hours per unit unless noted
 */
export const LABOR_HOURS = {
  // Soft Start buckets (mount, wire, bypass contactor, CB, HOA, test)
  soft_3hp:   8,
  soft_15hp:  14,
  soft_75hp:  22,
  // VFD buckets (rollout, mount, 3-phase wire, EIP config, program, test)
  vfd_3hp:    10,
  vfd_15hp:   16,
  vfd_75hp:   28,
  // Feeder / control bucket (CB, wire, label)
  feeder_bkt: 4,
  // Infrastructure
  structure_section: 6,   // Per vertical section: mount, bus, grounding, DIN
  main_breaker:      8,   // Main disconnect assembly + lugs
  bus_section:       2,   // Horizontal bus run per section
  xfmr_9kva:        12,  // Transformer bucket + wiring + PDP
  enip_switch:       4,   // EIP switch: mount, patch, configure
  meter:             6,   // Power meter: CT wiring, comms, program
  spd:               3,   // SPD: mount + wire
  cpt_section:       2,   // CPT per section
  psu_24v:           3,   // 24VDC PSU: mount + wire
  // Shop QA & ship
  shop_qa_pct:   0.15,  // 15% of assembly hours — UL508A Clause 18 test protocol
  shop_ship_hrs: 16,    // Crating, blocking, foam, ship prep (MCC = heavy)
};
